<template>
  <SfModalPortal
    modal-id="move-back-to-open-confirmation-modal"
    size="s"
    @opened="openModal"
    @close="closeModal"
  >
    <template #title>{{ copy.title }}</template>

    <template #messages>
      <SfModalMessage variant="warning">{{ copy.warning }}</SfModalMessage>
    </template>

    <template #body> </template>

    <template #footer>
      <span class="tw-flex tw-flex-row tw-gap-6 tw-mt-4">
        <SfButtonDs variant="secondary" @click="closeModal">
          {{ copy.cancelButton }}
        </SfButtonDs>
        <SfButtonDs variant="primary" @click="handleMoveBack">
          {{ copy.confirmButton }}
        </SfButtonDs>
      </span>
    </template>
  </SfModalPortal>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import {
  SfModalMessage,
  SfModalPortal,
} from '@app/shared/vue/components/sf-modal'
import useI18n from '@app/shared/vue/composables/use-I18n'
import { SfButtonDs } from '@silverfin/ui-components'
import api from '@app/application/communication/sections/communication/api/remark'
import { SfLog } from '@app/adapters/logger'
import type { Remark } from '@app/application/communication/types'

const I18n = useI18n()
const copy = {
  title: I18n.t('client_meetings.move_back_confirmation_modal.title'),
  warning: I18n.t('client_meetings.move_back_confirmation_modal.warning'),
  cancelButton: I18n.t(
    'client_meetings.move_back_confirmation_modal.cancel_button'
  ),
  confirmButton: I18n.t(
    'client_meetings.move_back_confirmation_modal.confirm_button'
  ),
}

const remark = ref<Remark | null>(null)

function openModal(params: { remark: Remark }) {
  remark.value = params.remark
}

function closeModal() {
  remark.value = null
  window.modalCitizen.closeModalPortal()
}

async function handleMoveBack() {
  if (!remark.value) return

  try {
    await api.updatePastClientMeetingRemark(
      remark.value.id,
      remark.value.companyId
    )
    window.eventHub.$emit('refreshCommunicationData')
    closeModal()
  } catch (e) {
    SfLog.warn('Error while moving remark back to open', {
      extra: { error: e, remarkId: remark.value.id },
    })
  }
}
</script>
